// components/LowStockAlert.jsx
import React from "react";
import { FiAlertTriangle } from "react-icons/fi";

const LowStockAlert = ({ count, onViewDetails }) => {
  if (count === 0) return null;

  return (
    <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-lg">
      <div className="flex items-start">
        <FiAlertTriangle
          className="text-red-500 mt-0.5 mr-3 flex-shrink-0"
          size={24}
        />
        <div className="flex-1">
          <h3 className="text-red-800 font-semibold mb-1">Low Stock Alert!</h3>
          <p className="text-red-700 text-sm mb-2">
            {count} product(s) need immediate attention
          </p>
          <button
            onClick={onViewDetails}
            className="text-red-800 text-sm font-semibold underline hover:text-red-900"
          >
            View Details →
          </button>
        </div>
      </div>
    </div>
  );
};

export default LowStockAlert;
